module.exports = __webpack_public_path__ + "static/media/35.7b85ddfe.png";